<div class="mt-8">
    <p *ngIf="!data.length" class="text-gray-600 text-center text-md">Ningún registro seleccionado</p>
    <ul *ngIf="data.length > 0" class="sidebar-list select-none">
        <li *ngFor="let item of data" class="item">
            <div class="flex justify-evenly">
                <p class="w-4/5">{{ item[displayNameProp] }}</p>
                <button class="text-gray-600"
                (click)="onRemove(item)">
                    <i class="fa-solid fa-circle-minus"></i>
                </button>
            </div>
        </li>
    </ul>
    <div *ngIf="totalPages && totalPages > currentPage" class="flex items-center justify-center">
        <button class="button-load-more"
        (click)="onLoadMore()">
            Cargar más...
        </button>
    </div>
</div>